import type { createRollbar } from "@sunrun/sales-experience-shared";

type RollbarClient = ReturnType<typeof createRollbar>;

/* eslint-disable @typescript-eslint/no-require-imports */
// Rollbar v3 is typed as ESM-only under moduleResolution node16; CRA/Jest resolve the CJS/UMD build via require.
const RollbarModule = require("rollbar") as {
  default?: new (options?: object) => RollbarClient;
} & (new (options?: object) => RollbarClient);

const Rollbar = RollbarModule.default ?? RollbarModule;

const rollbar = new Rollbar({
  accessToken: "946695f4471c42a1a4cc71dc41b2b81a",
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled:
    process.env.REACT_APP_ENV_NAME === "production" ||
    process.env.REACT_APP_ENV_NAME === "staging",
  payload: {
    environment: process.env.REACT_APP_ENV_NAME,
    context: "UI",
    client: {
      javascript: {
        guess_uncaught_frames: true,
        source_map_enabled: true,
      },
    },
  },
});

export { rollbar };
